// CompanySelect.jsx
import React, { useEffect, useState } from "react";
import { FormControl, InputLabel, Select, MenuItem, CircularProgress } from "@mui/material";
import { getCompanies } from "../../../api/companyService";

const CompanySelect = ({ value, onChange, label = "Select Company", ...props }) => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await getCompanies();
        const sortedCompanies = response.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
        setCompanies(sortedCompanies);
      } catch (error) {
        console.error("Error fetching companies:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCompanies();
  }, []);

  return (
    <FormControl fullWidth {...props}>
      <InputLabel>{label}</InputLabel>
      {loading ? (
        <CircularProgress size={24} />
      ) : (
        <Select value={value} onChange={onChange} label={label}>
          {companies.map((company) => (
            <MenuItem key={company.id} value={company.id}>
              {company.name}
            </MenuItem>
          ))}
        </Select>
      )}
    </FormControl>
  );
};

export default CompanySelect;